<template>
  <!-- Mobile top bar -->
  <v-app-bar
    v-if="isMobile"
    app
    flat
    height="58"
    class="topbar topbar--mobile"
  >
    <img src="../../assets/Images/pnglogo.png" alt="" class="mobile-logo" />
    <div class="mobile-title-wrap">
      <div class="mobile-brand">NATURESTAY</div>
      <div class="mobile-title">{{ title }}</div>
    </div>
    <v-spacer></v-spacer>
    <v-menu
      offset-y
      left
      transition="slide-y-transition"
      content-class="profile-menu"
      min-width="260"
    >
      <template v-slot:activator="{ on, attrs }">
        <button type="button" class="mobile-avatar" aria-label="Account menu" v-bind="attrs" v-on="on">
          {{ userInitials }}
        </button>
      </template>
      <div class="profile-menu-head">
        <div class="profile-menu-avatar">{{ userInitials }}</div>
        <div class="profile-menu-meta">
          <div class="profile-menu-name">{{ userName }}</div>
          <div class="profile-menu-role">{{ userRole }}</div>
        </div>
      </div>
      <div class="profile-menu-body">
        <router-link to="/profilepage" class="profile-menu-item">
          <v-icon small>mdi-account-circle-outline</v-icon>
          My profile
        </router-link>
        <button type="button" class="profile-menu-item profile-menu-item--danger" @click="$emit('logout')">
          <v-icon small>mdi-logout</v-icon>
          Logout
        </button>
      </div>
    </v-menu>
  </v-app-bar>

  <!-- Desktop top bar -->
  <v-app-bar
    v-else
    app
    flat
    height="68"
    color="white"
    class="topbar topbar--desktop"
  >
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          class="collapse-btn"
          :aria-label="mini ? 'Expand sidebar' : 'Collapse sidebar'"
          v-bind="attrs"
          v-on="on"
          @click="$emit('toggle-sidebar')"
        >
          <v-icon color="#13736f">{{ mini ? "mdi-menu" : "mdi-menu-open" }}</v-icon>
        </v-btn>
      </template>
      <span>{{ mini ? "Expand sidebar" : "Collapse sidebar" }}</span>
    </v-tooltip>

    <div class="page-heading">
      <div class="page-crumb">
        {{ subtitle }}
        <v-icon x-small color="#94a3b8">mdi-chevron-right</v-icon>
        <span>{{ title }}</span>
      </div>
      <div class="page-name">{{ title }}</div>
    </div>

    <v-spacer></v-spacer>

    <div class="date-pill hidden-md-and-down">
      <v-icon small color="#13736f">mdi-calendar-blank-outline</v-icon>
      {{ today }}
    </div>

    <v-menu
      offset-y
      left
      transition="slide-y-transition"
      content-class="profile-menu"
      min-width="260"
    >
      <template v-slot:activator="{ on, attrs, value }">
        <button
          type="button"
          class="profile-trigger"
          :class="{ 'profile-trigger--open': value }"
          v-bind="attrs"
          v-on="on"
        >
          <span class="profile-avatar">{{ userInitials }}</span>
          <span class="profile-meta">
            <span class="profile-name">{{ userName }}</span>
            <span class="profile-role">{{ userRole }}</span>
          </span>
          <v-icon small color="#64748b" class="profile-chevron">mdi-chevron-down</v-icon>
        </button>
      </template>
      <div class="profile-menu-head">
        <div class="profile-menu-avatar">{{ userInitials }}</div>
        <div class="profile-menu-meta">
          <div class="profile-menu-name">{{ userName }}</div>
          <div class="profile-menu-role">{{ userRole }}</div>
        </div>
      </div>
      <div class="profile-menu-body">
        <router-link to="/profilepage" class="profile-menu-item">
          <v-icon small>mdi-account-circle-outline</v-icon>
          My profile
        </router-link>
        <button type="button" class="profile-menu-item profile-menu-item--danger" @click="$emit('logout')">
          <v-icon small>mdi-logout</v-icon>
          Logout
        </button>
      </div>
    </v-menu>
  </v-app-bar>
</template>
<script>
import moment from "moment";

export default {
  props: {
    title: { type: String, default: "" },
    subtitle: { type: String, default: "" },
    isMobile: { type: Boolean, default: false },
    mini: { type: Boolean, default: false },
    userName: { type: String, default: "" },
    userRole: { type: String, default: "" },
    userInitials: { type: String, default: "" },
  },
  computed: {
    today() {
      return moment().format("ddd, D MMM YYYY");
    },
  },
};
</script>

<style scoped>
/* ---------- Desktop ---------- */
.topbar--desktop {
  background: rgba(255, 255, 255, 0.92) !important;
  backdrop-filter: blur(12px);
  border-bottom: 1px solid #e6edf0 !important;
}

.collapse-btn {
  margin-right: 8px;
  background: rgba(19, 115, 111, 0.08);
  border-radius: 12px !important;
}

.page-heading {
  min-width: 0;
}

.page-crumb {
  display: flex;
  align-items: center;
  gap: 2px;
  font-size: 12px;
  font-weight: 600;
  color: #94a3b8;
}

.page-crumb span {
  color: #13736f;
}

.page-name {
  font-size: 19px;
  font-weight: 800;
  color: #0f172a;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.date-pill {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-right: 14px;
  padding: 8px 14px;
  border-radius: 999px;
  background: #f1f7f6;
  font-size: 13px;
  font-weight: 600;
  color: #334155;
}

.profile-trigger {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 5px 10px 5px 5px;
  border-radius: 14px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  cursor: pointer;
  font-family: inherit;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.profile-trigger:hover,
.profile-trigger--open {
  border-color: rgba(19, 115, 111, 0.35);
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.08);
}

.profile-trigger--open .profile-chevron {
  transform: rotate(180deg);
}

.profile-chevron {
  transition: transform 0.2s ease;
}

.profile-avatar {
  width: 38px;
  height: 38px;
  border-radius: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #13736f 0%, #2a9d8f 100%);
  color: #ffffff;
  font-size: 14px;
  font-weight: 800;
}

.profile-meta {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: 180px;
  text-align: left;
}

.profile-name,
.profile-role {
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.profile-name {
  font-size: 14px;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.2;
}

.profile-role {
  font-size: 12px;
  color: #64748b;
}

/* ---------- Mobile ---------- */
.topbar--mobile {
  background: linear-gradient(120deg, #0c4f4c 0%, #13736f 60%, #1b857f 100%) !important;
  box-shadow: 0 4px 16px rgba(19, 115, 111, 0.25) !important;
}

.mobile-logo {
  width: 34px;
  height: 34px;
  object-fit: contain;
  margin-right: 10px;
}

.mobile-title-wrap {
  min-width: 0;
}

.mobile-brand {
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 1.5px;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.2;
}

.mobile-title {
  font-size: 16px;
  font-weight: 800;
  color: #ffffff;
  line-height: 1.25;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.mobile-avatar {
  width: 38px;
  height: 38px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.35);
  background: rgba(255, 255, 255, 0.15);
  color: #ffffff;
  font-family: inherit;
  font-size: 14px;
  font-weight: 800;
  cursor: pointer;
}

/* ---------- Profile menu (shared) ---------- */
.profile-menu-head {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  background: linear-gradient(120deg, #0c4f4c 0%, #13736f 100%);
}

.profile-menu-avatar {
  width: 44px;
  height: 44px;
  flex-shrink: 0;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fbbf24;
  color: #0c4f4c;
  font-size: 16px;
  font-weight: 800;
}

.profile-menu-meta {
  min-width: 0;
}

.profile-menu-name {
  font-size: 15px;
  font-weight: 700;
  color: #ffffff;
}

.profile-menu-role {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
}

.profile-menu-body {
  padding: 8px;
  background: #ffffff;
}

.profile-menu-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 12px;
  border: none;
  border-radius: 10px;
  background: none;
  cursor: pointer;
  text-decoration: none;
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  color: #334155;
  transition: background-color 0.2s ease;
}

.profile-menu-item .v-icon {
  color: inherit !important;
}

.profile-menu-item:hover {
  background: #f1f5f9;
}

.profile-menu-item--danger {
  color: #dc2626;
}

.profile-menu-item--danger:hover {
  background: #fef2f2;
}
</style>

<style>
/* Shared legacy helpers used by pages across the app. */
.mainbg {
  background-image: linear-gradient(269.6deg, #29807c -31.66%, #29807c);
}

input::-webkit-input-placeholder {
  color: #c5c5c5 !important;
  font-size: 14px !important;
  font-family: var(--font-body) !important;
}

input::-moz-placeholder {
  color: #c5c5c5 !important;
  font-size: 14px !important;
  font-family: var(--font-body) !important;
}

.custom-app-bar {
  z-index: 1000;
}

.searchBox .v-input__control {
  min-height: 10px !important;
}

.searchBox .v-input__control .v-input__slot {
  padding: 0px !important;
}

.profile-menu {
  border-radius: 16px !important;
  overflow: hidden;
  box-shadow: 0 18px 48px rgba(15, 23, 42, 0.18) !important;
  margin-top: 6px;
}
</style>
